export const LISTING_TYPE_URL_SEGMENT_MAP = {
  JOB: 'jobs',
  INTERNSHIP: 'internships',
  VOLOP: 'volops',
  EVENT: 'events',
  ORG: 'organizations',
  USER: 'users',
} as const;
